import { render, staticRenderFns } from "./TipsDesglose.vue?vue&type=template&id=7b3b8036&scoped=true&"
import script from "./TipsDesglose.vue?vue&type=script&lang=js&"
export * from "./TipsDesglose.vue?vue&type=script&lang=js&"
import style0 from "./TipsDesglose.vue?vue&type=style&index=0&id=7b3b8036&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3b8036",
  null
  
)

export default component.exports